import React from 'react';
import DiceDisplay from '../DiceDisplay';
import { Die } from '../../types';
import { PANEL_STYLES, HEADING_STYLES, SUBHEADING_STYLES } from '../../constants/styles';

interface MyDiceDisplayProps {
  myDice: Die[];
}

const MyDiceDisplay: React.FC<MyDiceDisplayProps> = ({ myDice }) => {
  return (
    <div className={PANEL_STYLES}>
      <h2 className={`${HEADING_STYLES} mb-1`}>Your Dice</h2>
      {myDice.length > 0 ? (
        <DiceDisplay dice={myDice} className="justify-center" size="sm" />
      ) : (
        <p className={`${SUBHEADING_STYLES} text-center`}>No dice</p>
      )}
    </div>
  );
};

export default MyDiceDisplay;